export class RacersEvent {
    /**
     * Construct a racers event
     * @param {number} frame The frame this event takes place at     */
    constructor(frame) {
        this.frame = frame;
    }
}